import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // model
  serviceRssModel: [],

  //form
  serviceId: null,
  buttonId: null,
  index: 0,

  // 選択された配信タイプリスト
  value: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}, {serviceId, buttonId, index, data}) {
		// cover
		this.dispatch('core/showModalCover')
		
    commit('reset')
    commit('setServiceId', serviceId)
    commit('setButtonId', buttonId)
    if (index !== undefined) commit('setIndex', index)
    commit('setValue', data)
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceRssParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceRss'],
        ['v1ServiceRssListGet'],
        [serviceRssParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceRssModel', res[0].data.serviceRssSettings)
            console.log('serviceRssModel', state.serviceRssModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 選択されたファイル情報を保持
   */
  setValue ({commit}, data) {
    commit('setValue', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setServiceRssModel (state, data) {
    Vue.set(state, 'serviceRssModel', data)
  },
  
  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setButtonId (state, id) {
    state.buttonId = id
  },
  setIndex (state, index) {
    state.index = index
  },
  setValue (state, data) {
    Vue.set(state, 'value', data)
  },

  // reset
  reset (state) {
    Vue.set(state, 'serviceRssModel', [])
    Vue.set(state, 'value', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
